import { HasProductContext, ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import * as React from "react";

export interface CustomHasProductContext extends HasProductContext {
    productContext: CustomProductContextModel;
}

export interface CustomProductContextModel extends ProductContextModel {
    onWarehouseChanged?: (warehouseId: string) => void;
}

export type CustomHasProduct = CustomProductContextModel;

export const CustomProductContext = React.createContext<CustomProductContextModel>({} as any);

export function withProductContext<P extends CustomHasProductContext>(Component: React.ComponentType<P>) {
    return function ProductComponent(props: Omit<P, keyof CustomHasProductContext>) {
        return (
            <CustomProductContext.Consumer>
                {value => <Component {...(props as P)} productContext={value} />}
            </CustomProductContext.Consumer>
        );
    };
}

export function withProduct<P extends CustomHasProduct>(Component: React.ComponentType<P>) {
    return function ProductComponent(props: Omit<P, keyof CustomHasProduct>) {
        return (
            <CustomProductContext.Consumer>
                {value => (
                    <Component
                        {...(props as P)}
                        product={value.product}
                        productInfo={value.productInfo}
                        onQtyOrderedChanged={value.onQtyOrderedChanged}
                        onUnitOfMeasureChanged={value.onUnitOfMeasureChanged}
                    />
                )}
            </CustomProductContext.Consumer>
        );
    };
}